<template>
  <div class="text-left font_Montserrat">
    <div
      class="preamble v2_font_style_italic v2_font_size_20 v2_color_black"
      v-if="jobQuestion.member_preamble"
      v-html="memberPreamble"
    />

    <div
      class="prompt font_size_1500rem v2_font_weight_semibold"
      v-if="jobQuestion.member_prompt"
      v-html="memberPrompt"
    />

    <div
      class="font_size_1000rem v2_color_black my-3"
      v-if="jobQuestion.member_explanation"
      v-html="memberExplanation"
    />
  </div>
</template>

<script>
import sanitizeHtml from 'sanitize-html';
import Utils from '@/providers/Utils';

const replaceUnderline = (text) =>
  sanitizeHtml(Utils.replaceUnderlineMarkersWithTags(text));

export default {
  name: 'IcoQuestionBlock',
  props: {
    jobQuestion: Object,
  },
  computed: {
    memberPreamble: function () {
      return replaceUnderline(this.jobQuestion.member_preamble);
    },
    memberPrompt: function () {
      return replaceUnderline(this.jobQuestion.member_prompt);
    },
    memberExplanation: function () {
      return replaceUnderline(this.jobQuestion.member_explanation);
    },
  },
};
</script>

<style scoped></style>
